const menu = {
  key: "activities",
  route: "/legacy/activities",
  label: "sidebar.activities",
  icon: "faTasks",
  group: "sales",
  order: 40,
  permission: "legacy.activities.read"
};

export default menu;